import { Trans } from "@lingui/react/macro";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { DeleteChannelDialog } from "~/components/channels/delete-channel-dialog";
import { Button } from "~/components/ui/button";
import {
	FormCard,
	FormCardBody,
	FormCardHeader,
	FormCardHeaderSubtitle,
	FormCardHeaderTitle,
} from "~/components/ui/form-card";
import { Label } from "~/components/ui/label";
import { ChannelStatus } from "~/models/channel";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/settings/settings",
)({
	component: Page,
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const navigate = useNavigate();

	const { data: channel } = useSuspenseQuery(
		trpc.channel.find.queryOptions({ channelUid }),
	);

	return (
		<div className="grid gap-6 w-full px-4">
			<FormCard className="border-destructive">
				<FormCardHeader>
					<div>
						<FormCardHeaderTitle>
							<Trans>Danger Zone</Trans>
						</FormCardHeaderTitle>
						<FormCardHeaderSubtitle>
							<Trans>
								Careful with this section, it can permanently affect your
								podcast.
							</Trans>
						</FormCardHeaderSubtitle>
					</div>
				</FormCardHeader>
				<FormCardBody>
					<section className="space-y-6">
						{[ChannelStatus.Removed, ChannelStatus.Removed_TS].includes(
							channel.statusID,
						) ? (
							<div className="grid gap-2">
								<div className="flex gap-3">
									<div className="flex grow flex-col gap-2">
										<div className="flex-1">
											<div className="flex items-center justify-between">
												<Label>
													<Trans>Restore this episode</Trans>
												</Label>
											</div>
											<div className="mt-1 text-sm text-muted-foreground">
												<Trans>
													This episode is deleted and cannot be restored.
												</Trans>
											</div>
										</div>
									</div>
									<Button disabled variant="outline">
										<Trans>Restore</Trans>
									</Button>
								</div>
							</div>
						) : (
							<div className="grid gap-2">
								<div className="flex gap-3">
									<div className="flex grow flex-col gap-2">
										<div className="flex-1">
											<div className="flex items-center justify-between">
												<Label>
													<Trans>Delete this podcast</Trans>
												</Label>
											</div>
											<div className="mt-1 text-sm text-muted-foreground">
												<Trans>
													Once you delete a podcast, it's removed from your
													dashboard and you won't be able to recover it.
												</Trans>
											</div>
										</div>
									</div>
									<DeleteChannelDialog
										channelUid={channelUid}
										onSuccess={() => navigate({ to: "/" })}
									/>
								</div>
							</div>
						)}
					</section>
				</FormCardBody>
			</FormCard>
		</div>
	);
}
